module.exports = __webpack_public_path__ + "img/cover.6d63ade8.webp";